import WIDGETS from './widgets';

export default {
  name: 'tag_files',
  spacing: 0,
	direction: 'column',
	widgets: [
		{ content: WIDGETS.GOBACKFILETAGS, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
		{ content: WIDGETS.TAGSFILE, breakpoints: { xs: 12, sm: 12 } },
	],
};
